import { UploadFile } from "antd";
import noop from "lodash/noop";
import { useState, useCallback, useMemo } from "react";

import { ImageUploadFieldProps, UseImageUploadFieldReturnType } from "./types";

export const useImageUploadField = ({
  onChange = noop,
  value,
}: ImageUploadFieldProps): UseImageUploadFieldReturnType => {
  const [isPreviewModalOpened, setIsPreviewModalOpened] = useState(false);

  return {
    onPreview: useCallback(() => {
      setIsPreviewModalOpened(true);
    }, []),
    onCancel: useCallback(() => {
      setIsPreviewModalOpened(false);
    }, []),
    beforeUpload: useCallback(
      (file) => {
        const uploadFile: UploadFile = file;

        uploadFile.originFileObj = file;
        uploadFile.url = URL.createObjectURL(file);

        onChange(uploadFile);

        return false;
      },
      [onChange]
    ),
    onRemove: useCallback(() => {
      onChange(undefined);
    }, [onChange]),
    fileList: useMemo(() => {
      if (!value) {
        return [];
      }

      const fileItem =
        "uid" in value
          ? value
          : {
              ...value,
              type: value.type || "",
              uid: value.id.toString(),
              size: value.size || 0,
              name: value.name || "",
              url: value.url || "",
            };

      return [fileItem];
    }, [value]),
    isPreviewModalOpened,
    url: useMemo(() => {
      if (!value || !value.url) {
        return undefined;
      }

      return value.url;
    }, [value]),
    title: useMemo(() => {
      if (!value || !value.name) {
        return undefined;
      }

      return "fileName" in value ? value.fileName : value.name;
    }, [value]),
  };
};
